import { ReactNode } from 'react';

import WelcomeBackScreen from '../../components/authentication/WelcomeBackScreen';
import WelcomeScreen from '../../components/authentication/WelcomeScreen';
import { useAppSelector } from '../store/hooks';

const DialogsWrapper = ({ children }: { children: ReactNode }) => {

  const isExistingUser = useAppSelector(state => state.auth.isExistingUser);

  if (isExistingUser === true) return (
    <>
      <WelcomeBackScreen />
      {children}
    </>
  )
  if (isExistingUser === false) return (
    <>
      <WelcomeScreen />
      {children}
    </>
  )
  return <>
    {children}
  </>
}

export default DialogsWrapper;